<!-- 项目 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()" v-permission="['sale:report:edit']"> 新增</el-button>
          <el-button icon="el-icon-upload2" @click="downloadExcel()" v-permission="['sale:report:export']">导出</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :edit-rules="validRules"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button
            type="text"
            icon="el-icon-view"
            style="color:#4084B7;"
            @click="look(scope.row)"
          />
          <el-button
            type="text"
            size="mini"
            icon="el-icon-edit"
            style="color:#4084B7"
            v-permission="['sale:report:edit']"
            @click="edit(scope.row)"
          ></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180" v-permission="['sale:report:del']">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                :loading="delLoading"
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              slot="reference"
            ></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
    <drag-dialog
      append-to-body
      :show.sync="dialogVisible"
      title="销售机会人天汇报"
      :enableDrag="true"
      width="500px"
      @close="dialogVisible = false"
    >
    <span style="color: red; font-size: 14px;">注：如事项中含跨月工时，请分两次填写，事件时间选择对应月份的时间。
        <br/>
        例如：2月28日~3月4日这周工时，可分两次填报2月28日（1天），3月4日（4天）</span>
      <dynamic-form
        :formConfig="formConfig"
        labelWidth="100px"
        v-model="form"
        :disabled="!isEdit"
        @submit="submit"
        @cancelForm="dialogVisible = false"
        @getContent="getContent"
        ref="pageForm"
      ></dynamic-form>
    </drag-dialog>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { deleteSalePeopleReport, getSalePeopleReport, addSave, exportFilePost } from "@/api/sale/report"
import DragDialog from "@/components/DragDialog";
import "@/components/dynamic-form";
import { parseTime } from "@/utils";
import { deepClone } from "@/utils/index";
export default {
  name: "ReportIndex",
  directives: {},
  filters: {},
  mixins: [DataTableMixin],
  props: {},
  components: {
    DynamicSearch,
    DragDialog
  },
  data() {
    return {
      delLoading: false,
      tableHead: [
        {
          prop: "businessName",
          label: "商机名称",
          query: {
            type: "input"
          }
        },
        {
          prop: "businessNumber",
          label: "商机编码",
          query: {
            type: "input"
          }
        },
        {
          prop: "businessStage",
          label: "商机阶段",
        },
        {
          prop: "reportDay",
          label: "事项人天",
        },
        /* {
          prop: "businessUser",
          label: "销售人",
          hidden: true,
          query: {
            type: 'input'
          }
        }, */
        {
          prop: "reportUser",
          label: "任务人",
          query: {
            type: 'input'
          }
        },
        {
          prop: "reportDate",
          label: "事项日期",
          query: {
            type: "datetimerange",
            key: "reportDate"
          }
        },
        {
          prop: "createTime",
          label: "汇报时间"
        }
      ],
      validRules: {
        code: [{ required: true, message: "请输入键值", trigger: "blur" }],
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        customer: [{ required: true, message: "客户不能为空", trigger: "blur" }]
      },
      form: {},
      dialogVisible: false,
      isEdit: true,
      formConfig: {
        formItemList: [
          {
            type: "databox",
            key: "businessNumberVo",
            label: "商机编号",
            url: "/businessManage/getList",
            multiple: false,
            isShowConfirm: false,
            props: {
              label: "businessNumber",
              value: "id"
            },
            extendParms: { status: 0 },
            tableColumn: [
              {
                property: "businessNumber",
                label: "商机编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "businessName",
                label: "商机名称",
                query: {
                  type: "input"
                }
              },
              {
                property: "businessStage",
                label: "商机阶段"
              },
              {
                property: "terminalHolder",
                label: "销售机会所有人",
                query: {
                  type: "input"
                }
              },
              {
                property: "terminalCustomerName",
                label: "终端客户名称",
                query: {
                  type: "input"
                }
              },
            ],
            rules: [
              { required: true, message: "商机编号不能为空", trigger: "change" }
            ]
          },
          {
            type: "input",
            key: "businessName",
            label: "商机名称",
            value: "",
            disabled: true,
            rules: [
              { required: true, message: "商机名称不能为空", trigger: "blur" }
            ]
          },
          {
            label: "商机阶段",
            key: "businessStage",
            type: "input",
            disabled: true,
            rules: { required: true, message: "不能为空", trigger: "change" }
          },
          {
            label: '终端客户名称',
            key: 'terminalCustomerName',
            type: "input",
            disabled: true,
          },
          {
            label: '事项人天',
            type: 'inputNumber',
            min: 0.1,
            key: 'reportDay',
            hidden: false,
            placeholder: "请输入事项人天",
            rules: { required: true, message: "不能为空", trigger: "change" }
          },
          {
            label: '事项时间',
            key: 'reportDate',
            type: "date",
            valueFormat: "yyyy-MM-dd",
            rules: { required: true, message: "不能为空", trigger: "change" },
            placeholder: "请选择",
            pickerTime: {
              disabledDate: (time) => {
                const myDate = this.$parseDate()
                const date = myDate.toLocaleDateString().split('/')
                return time.getTime() > this.$parseDate(date).getTime()
              }
            }
          },
          {
            type: "textarea",
            key: "reportText",
            label: "汇报事项",
            value: "",
            placeholder: "请输入事项",
            rules: [
              { required: true, message: "不能为空", trigger: "blur" }
            ]
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      // console.log(1);
      this.dataTableInit();
    });
  },
  methods: {
    formatter (val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    editActiveEvent(row, column) {
      console.log(row, column);
    },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/salePeopleReport/getList`;
      const params = { page: this.page, size: this.offset,};
      if (this._query.reportDate) {
        params.reportStartDate = this.formatter(this._query.reportDate[0])
        params.reportEndDate = this.formatter(this._query.reportDate[1])
        delete this._query.reportDate
      }
      this._params = Object.assign(params, this._query);
      // delete this._params.reportDate
      return true;
    },
    handleDeletes(rows) {
      rows.forEach(element => {
        this.subDelete(element.id);
      });
    },
    subDelete(id) {
      this.delLoading = true;
      deleteSalePeopleReport(id).then(res => {
        this.delLoading = false;
        this.$refs[id].doClose();
        this.dleTableChangePage();
        this.dataTableInit();
        this.$notify({
          title: "删除成功",
          type: "success",
          duration: 2500
        });
      }).catch(err => {
        this.delLoading = false;
        this.$refs[id].doClose();
        console.log(err);
      });
    },
    add(row) {
      this.form = {}
      // this.$router.push(`/report/form?id=${row.id}`);
      // this.form.reportDate = parseTime(new Date(),'{y}-{m}-{d}')
      this.form.reportUserId = this.$store.state.user.user.id
      this.form.reportUser = this.$store.state.user.user.name
      this.isEdit = true
      this.dialogVisible = true
    },
    submit() {
      this.$refs.pageForm.validate().then(() => {
        const data = deepClone(this.form);
        this.loading = true;
        addSave(data).then(res => {
          // this.resetForm();
          this.$notify({
            title: "添加成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.dialogVisible = false
          this.dataTableInit();
        }).catch(err => {
          this.loading = false;
          console.log(err);
        });
      });
    },
    getContent(val) {
      if (val.key === 'businessNumberVo') {
        this.form.businessName = val.value.businessName
        this.form.businessNumber = val.value.businessNumber
        this.form.businessStage = val.value.businessStage
        this.form.terminalCustomerName = val.value.terminalCustomerName
        this.form.businessManageId = val.value.id
      }
    },
    // 修改
    async edit(row) {
      const result = await getSalePeopleReport(row.id);
      const form = result.data;
      this.form = form;
      this.form.businessNumberVo = { id: this.form.businessManageId, businessName: this.form.businessName, businessNumber: this.form.businessNumber,
        businessStage: this.form.businessStage }
      this.isEdit = true
      this.dialogVisible = true;
    },
    // 查看
    async look(row) {
      const result = await getSalePeopleReport(row.id);
      const form = result.data;
      this.form = form;
      this.form.businessNumberVo = { id: this.form.businessManageId, businessName: this.form.businessName, businessNumber: this.form.businessNumber,
        businessStage: this.form.businessStage }
      this.isEdit = false
      this.dialogVisible = true;
    },
    downloadExcel() {
      if (this._query.reportDate) {
        this._query.reportStartDate = this.formatter(this._query.reportDate[0])
        this._query.reportEndDate = this.formatter(this._query.reportDate[1])
        delete this._query.reportDate
      }
      console.log(this.formatter(new Date()))
      exportFilePost(`/salePeopleReport/exportExcel`, this.formatter(new Date()) + '导出商机汇报人天.xls', this._query)
    },
  }
};
</script>

<style lang="scss" scoped>
</style>